
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function FoamExtinguishersPage() {
  const { id } = useParams();

  const product = {
    id: 6,
    title: 'Foam Fire Extinguishers',
    category: 'Fire Extinguishers',
    brand: 'FlameGuardQA',
    model: 'FG-AFFF-01',
    certification: 'AFFF Formula',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20foam%20fire%20extinguisher%20with%20cream%20colored%20body%20and%20red%20components%2C%20AFFF%20fire%20suppression%20equipment%20for%20liquid%20fires%20with%20QCDD%20approval%20and%20technical%20specifications%20label%20mounted%20on%20wall%20bracket&width=600&height=600&seq=foam-extinguisher-detail&orientation=squarish',
    description: 'AFFF foam extinguishers designed for Class A and B fires, especially effective on flammable liquid fires. The foam creates a blanket effect that prevents re-ignition and provides superior fire suppression.'
  };

  const features = [
    'AFFF foam formula for liquid fires',
    'Quick knock-down effect on flames',
    'Corrosion-resistant body construction',
    'Safe and eco-friendly agent',
    'Prevents re-ignition with foam blanket',
    'Suitable for Class A and B fires',
    'Easy maintenance and refilling',
    'Trolley mounted options available'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-AFFF-01' },
    { label: 'Type', value: 'AFFF Foam Fire Extinguisher' },
    { label: 'Capacity', value: '9L / 50L trolley' },
    { label: 'Foam Concentrate', value: '3% AFFF' },
    { label: 'Working Pressure', value: '12 bar' },
    { label: 'Discharge Time', value: '60–90 seconds' },
    { label: 'Discharge Range', value: '4–6 meters' },
    { label: 'Fire Classes', value: 'Class A & B' },
    { label: 'Cylinder Material', value: 'Steel with Epoxy Coating' },
    { label: 'Operating Temperature', value: '-10°C to +60°C' },
    { label: 'Weight (9L)', value: '15kg total' },
    { label: 'Certification', value: 'QCDD, EN3' },
    { label: 'Warranty', value: '2 Years' }
  ];

  const relatedProducts = [
    {
      id: 4,
      title: 'CO₂ Fire Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Professional%20red%20CO2%20fire%20extinguisher%20with%20black%20horn%20and%20pressure%20gauge%2C%20QCDD%20approved%20clean%20agent%20fire%20suppression%20equipment%20for%20electrical%20fires%20with%20technical%20specifications%20label&width=300&height=200&seq=co2-extinguisher-related2&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'QCDD Approved'
    },
    {
      id: 5,
      title: 'Dry Chemical Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Red%20ABC%20dry%20chemical%20fire%20extinguisher%20with%20pressure%20gauge%20and%20safety%20pin%2C%20professional%20multi-purpose%20fire%20suppression%20equipment%20with%20QCDD%20certification%20marking%20and%20technical%20specifications&width=300&height=200&seq=dry-chemical-related2&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'ABC Class Rated'
    },
    {
      id: 7,
      title: 'Sprinkler Heads & Systems',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20heads%20installed%20in%20ceiling%20with%20red%20pipes%20and%20brass%20fittings%2C%20QCDD%20approved%20sprinkler%20system%20with%20various%20temperature%20ratings%20and%20spray%20patterns%20in%20Qatar%20commercial%20building&width=300&height=200&seq=sprinkler-heads-related&orientation=landscape',
      category: 'Sprinklers',
      compliance: 'UL Listed'
    },
    {
      id: 17,
      title: 'Fire Extinguisher Cabinets',
      image: 'https://readdy.ai/api/search-image?query=Red%20steel%20fire%20extinguisher%20cabinet%20with%20glass%20viewing%20window%20and%20lock%2C%20professional%20fire%20safety%20equipment%20storage%20with%20QCDD%20approval%20marking%20mounted%20on%20white%20wall&width=300&height=200&seq=extinguisher-cabinets-related3&orientation=landscape',
      category: 'Accessories',
      compliance: 'Weather Resistant'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
